var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _g, _path416, _path417, _g2, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZeeroVehicle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.639 45.0438H111.562C111.562 45.0438 114.347 37.4375 118.631 37.4375C122.915 37.4375 124.259 42.6855 124.259 42.6855C124.259 42.6855 127.149 39.8352 129.524 39.8352C131.899 39.8352 133.962 43.6203 133.962 43.6203C133.962 43.6203 137.317 41.5769 139.639 45.0438Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.136 25.4984H102.016C102.016 25.4984 104.948 21.2344 107.264 21.2344C109.579 21.2344 110.258 24.065 110.258 24.065C110.258 24.065 111.898 22.753 113.397 22.9826C114.896 23.2122 115.136 25.4984 115.136 25.4984Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8045 48.6881H19.25C19.25 48.6881 22.7498 40.8752 26.4922 40.3864C30.2347 39.8977 32.0289 46.192 32.0289 46.192C32.0289 46.192 34.443 43.9682 36.3421 43.9682C38.2412 43.9682 39.6942 46.8972 39.6942 46.8972C39.6942 46.8972 43.5023 44.8899 44.8045 48.6881Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3128 15.8694H54.0469C54.0469 15.8694 56.9989 10.2081 60.233 10.1261C63.467 10.0441 65.153 14.4098 65.153 14.4098C65.153 14.4098 70.1451 10.3951 71.3128 15.8694Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9787 31.5306H78.3281C78.3281 31.5306 80.3289 27.7094 82.5003 27.6569C84.6716 27.6045 85.8131 30.5466 85.8131 30.5466C85.8131 30.5466 89.1915 27.8373 89.9787 31.5306Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.998 49.8594H108.062V112.435H119.998V49.8594Z",
    fill: "#DBDBDB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.233 51.8906H109.914V54.2785H112.233V51.8906Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.202 51.8906H112.883V54.2785H115.202V51.8906Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.233 55.9531H109.914V58.341H112.233V55.9531Z",
    fill: "#EBEBEB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M115.202 55.9531H112.883V58.341H115.202V55.9531Z",
    fill: "#EBEBEB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M112.233 60.0078H109.914V62.3957H112.233V60.0078Z",
    fill: "#EBEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M115.202 60.0078H112.883V62.3957H115.202V60.0078Z",
    fill: "#EBEBEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M112.233 64.0625H109.914V66.4503H112.233V64.0625Z",
    fill: "#EBEBEB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M115.202 64.0625H112.883V66.4503H115.202V64.0625Z",
    fill: "#EBEBEB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M112.233 68.125H109.914V70.5128H112.233V68.125Z",
    fill: "#EBEBEB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M115.202 68.125H112.883V70.5128H115.202V68.125Z",
    fill: "#EBEBEB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M112.233 72.1797H109.914V74.5675H112.233V72.1797Z",
    fill: "#EBEBEB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M115.202 72.1797H112.883V74.5675H115.202V72.1797Z",
    fill: "#EBEBEB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M112.233 76.2344H109.914V78.6222H112.233V76.2344Z",
    fill: "#EBEBEB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M115.202 76.2344H112.883V78.6222H115.202V76.2344Z",
    fill: "#EBEBEB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M112.233 80.2969H109.914V82.6847H112.233V80.2969Z",
    fill: "#EBEBEB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M115.202 80.2969H112.883V82.6847H115.202V80.2969Z",
    fill: "#EBEBEB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M112.233 84.3516H109.914V86.7394H112.233V84.3516Z",
    fill: "#EBEBEB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M115.202 84.3516H112.883V86.7394H115.202V84.3516Z",
    fill: "#EBEBEB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M112.233 88.4062H109.914V90.7941H112.233V88.4062Z",
    fill: "#EBEBEB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M115.202 88.4062H112.883V90.7941H115.202V88.4062Z",
    fill: "#EBEBEB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M112.233 92.4531H109.914V94.841H112.233V92.4531Z",
    fill: "#EBEBEB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M115.202 92.4531H112.883V94.841H115.202V92.4531Z",
    fill: "#EBEBEB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M112.233 96.5156H109.914V98.9035H112.233V96.5156Z",
    fill: "#EBEBEB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M115.202 96.5156H112.883V98.9035H115.202V96.5156Z",
    fill: "#EBEBEB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M112.233 100.578H109.914V102.966H112.233V100.578Z",
    fill: "#EBEBEB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M115.202 100.578H112.883V102.966H115.202V100.578Z",
    fill: "#EBEBEB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M112.233 104.625H109.914V107.013H112.233V104.625Z",
    fill: "#EBEBEB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M115.837 107.023H118.156V104.636H115.837V107.023Z",
    fill: "#EBEBEB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M115.837 102.969H118.156V100.581H115.837V102.969Z",
    fill: "#EBEBEB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M115.837 98.9062H118.156V96.5184H115.837V98.9062Z",
    fill: "#EBEBEB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M115.837 94.8516H118.156V92.4637H115.837V94.8516Z",
    fill: "#EBEBEB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M115.837 90.7969H118.156V88.409H115.837V90.7969Z",
    fill: "#EBEBEB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M115.837 86.7344H118.156V84.3465H115.837V86.7344Z",
    fill: "#EBEBEB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M115.837 82.6875H118.156V80.2997H115.837V82.6875Z",
    fill: "#EBEBEB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M115.837 78.625H118.156V76.2372H115.837V78.625Z",
    fill: "#EBEBEB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M115.837 74.5625H118.156V72.1747H115.837V74.5625Z",
    fill: "#EBEBEB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M115.837 70.5156H118.156V68.1278H115.837V70.5156Z",
    fill: "#EBEBEB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M115.837 66.4531H118.156V64.0653H115.837V66.4531Z",
    fill: "#EBEBEB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M115.837 62.4062H118.156V60.0184H115.837V62.4062Z",
    fill: "#EBEBEB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M115.837 58.3438H118.156V55.9559H115.837V58.3438Z",
    fill: "#EBEBEB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M115.837 54.2891H118.156V51.9012H115.837V54.2891Z",
    fill: "#EBEBEB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M115.202 104.625H112.883V107.013H115.202V104.625Z",
    fill: "#EBEBEB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M129.41 49.8594H120V112.435H129.41V49.8594Z",
    fill: "#A6A6A6"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M126.53 107.023H128.445V104.636H126.53V107.023Z",
    fill: "#C7C7C7"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M124.084 107.023H126V104.636H124.084V107.023Z",
    fill: "#C7C7C7"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M126.53 102.969H128.445V100.581H126.53V102.969Z",
    fill: "#C7C7C7"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M124.084 102.969H126V100.581H124.084V102.969Z",
    fill: "#C7C7C7"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M126.53 98.9062H128.445V96.5184H126.53V98.9062Z",
    fill: "#C7C7C7"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M124.084 98.9062H126V96.5184H124.084V98.9062Z",
    fill: "#C7C7C7"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M126.53 94.8516H128.445V92.4637H126.53V94.8516Z",
    fill: "#C7C7C7"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M124.084 94.8516H126V92.4637H124.084V94.8516Z",
    fill: "#C7C7C7"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M126.53 90.7969H128.445V88.409H126.53V90.7969Z",
    fill: "#C7C7C7"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M124.084 90.7969H126V88.409H124.084V90.7969Z",
    fill: "#C7C7C7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M126.53 86.7344H128.445V84.3465H126.53V86.7344Z",
    fill: "#C7C7C7"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M124.084 86.7344H126V84.3465H124.084V86.7344Z",
    fill: "#C7C7C7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M126.53 82.6875H128.445V80.2997H126.53V82.6875Z",
    fill: "#C7C7C7"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M124.084 82.6875H126V80.2997H124.084V82.6875Z",
    fill: "#C7C7C7"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M126.53 78.625H128.445V76.2372H126.53V78.625Z",
    fill: "#C7C7C7"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M124.084 78.625H126V76.2372H124.084V78.625Z",
    fill: "#C7C7C7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M126.53 74.5625H128.445V72.1747H126.53V74.5625Z",
    fill: "#C7C7C7"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M124.084 74.5625H126V72.1747H124.084V74.5625Z",
    fill: "#C7C7C7"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M126.53 70.5156H128.445V68.1278H126.53V70.5156Z",
    fill: "#C7C7C7"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M124.084 70.5156H126V68.1278H124.084V70.5156Z",
    fill: "#C7C7C7"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M126.53 66.4531H128.445V64.0653H126.53V66.4531Z",
    fill: "#C7C7C7"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M124.084 66.4531H126V64.0653H124.084V66.4531Z",
    fill: "#C7C7C7"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M126.53 62.4062H128.445V60.0184H126.53V62.4062Z",
    fill: "#C7C7C7"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M124.084 62.4062H126V60.0184H124.084V62.4062Z",
    fill: "#C7C7C7"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M126.53 58.3438H128.445V55.9559H126.53V58.3438Z",
    fill: "#C7C7C7"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M124.084 58.3438H126V55.9559H124.084V58.3438Z",
    fill: "#C7C7C7"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M126.53 54.2891H128.445V51.9012H126.53V54.2891Z",
    fill: "#C7C7C7"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M123.556 51.8906H121.641V54.2785H123.556V51.8906Z",
    fill: "#C7C7C7"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M123.556 55.9531H121.641V58.341H123.556V55.9531Z",
    fill: "#C7C7C7"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M123.556 60.0078H121.641V62.3957H123.556V60.0078Z",
    fill: "#C7C7C7"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M123.556 64.0625H121.641V66.4503H123.556V64.0625Z",
    fill: "#C7C7C7"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M123.556 68.125H121.641V70.5128H123.556V68.125Z",
    fill: "#C7C7C7"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M123.556 72.1797H121.641V74.5675H123.556V72.1797Z",
    fill: "#C7C7C7"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M123.556 76.2344H121.641V78.6222H123.556V76.2344Z",
    fill: "#C7C7C7"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M123.556 80.2969H121.641V82.6847H123.556V80.2969Z",
    fill: "#C7C7C7"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M123.556 84.3516H121.641V86.7394H123.556V84.3516Z",
    fill: "#C7C7C7"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M123.556 88.4062H121.641V90.7941H123.556V88.4062Z",
    fill: "#C7C7C7"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M123.556 92.4531H121.641V94.841H123.556V92.4531Z",
    fill: "#C7C7C7"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M123.556 96.5156H121.641V98.9035H123.556V96.5156Z",
    fill: "#C7C7C7"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M123.556 100.578H121.641V102.966H123.556V100.578Z",
    fill: "#C7C7C7"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M123.556 104.625H121.641V107.013H123.556V104.625Z",
    fill: "#C7C7C7"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M124.084 54.2891H126V51.9012H124.084V54.2891Z",
    fill: "#C7C7C7"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5188 46.4922H32.3984V112.44H46.5188V46.4922Z",
    fill: "#EBEBEB"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M46.524 45.0469H32.0625V46.4901H46.524V45.0469Z",
    fill: "#C7C7C7"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M35.102 48.625H33.6719V112.447H35.102V48.625Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6332 48.625H36.2031V112.447H37.6332V48.625Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1723 48.625H38.7422V112.447H40.1723V48.625Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7113 48.625H41.2812V112.447H42.7113V48.625Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2426 48.625H43.8125V112.447H45.2426V48.625Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M35.102 50.4453H33.6719V53.2956H35.102V50.4453Z",
    fill: "#EBEBEB"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6332 50.4453H36.2031V53.2956H37.6332V50.4453Z",
    fill: "#EBEBEB"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1723 50.4453H38.7422V53.2956H40.1723V50.4453Z",
    fill: "#EBEBEB"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7113 50.4453H41.2812V53.2956H42.7113V50.4453Z",
    fill: "#EBEBEB"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2426 50.4453H43.8125V53.2956H45.2426V50.4453Z",
    fill: "#EBEBEB"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M35.102 55.0781H33.6719V57.9284H35.102V55.0781Z",
    fill: "#EBEBEB"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6332 55.0781H36.2031V57.9284H37.6332V55.0781Z",
    fill: "#EBEBEB"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1723 55.0781H38.7422V57.9284H40.1723V55.0781Z",
    fill: "#EBEBEB"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7113 55.0781H41.2812V57.9284H42.7113V55.0781Z",
    fill: "#EBEBEB"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2426 55.0781H43.8125V57.9284H45.2426V55.0781Z",
    fill: "#EBEBEB"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M35.102 59.7031H33.6719V62.5534H35.102V59.7031Z",
    fill: "#EBEBEB"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6332 59.7031H36.2031V62.5534H37.6332V59.7031Z",
    fill: "#EBEBEB"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1723 59.7031H38.7422V62.5534H40.1723V59.7031Z",
    fill: "#EBEBEB"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7113 59.7031H41.2812V62.5534H42.7113V59.7031Z",
    fill: "#EBEBEB"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2426 59.7031H43.8125V62.5534H45.2426V59.7031Z",
    fill: "#EBEBEB"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M35.102 64.3438H33.6719V67.1941H35.102V64.3438Z",
    fill: "#EBEBEB"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6332 64.3438H36.2031V67.1941H37.6332V64.3438Z",
    fill: "#EBEBEB"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1723 64.3438H38.7422V67.1941H40.1723V64.3438Z",
    fill: "#EBEBEB"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7113 64.3438H41.2812V67.1941H42.7113V64.3438Z",
    fill: "#EBEBEB"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2426 64.3438H43.8125V67.1941H45.2426V64.3438Z",
    fill: "#EBEBEB"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M35.102 68.9688H33.6719V71.8191H35.102V68.9688Z",
    fill: "#EBEBEB"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6332 68.9688H36.2031V71.8191H37.6332V68.9688Z",
    fill: "#EBEBEB"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1723 68.9688H38.7422V71.8191H40.1723V68.9688Z",
    fill: "#EBEBEB"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7113 68.9688H41.2812V71.8191H42.7113V68.9688Z",
    fill: "#EBEBEB"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2426 68.9688H43.8125V71.8191H45.2426V68.9688Z",
    fill: "#EBEBEB"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M35.102 73.6094H33.6719V76.4597H35.102V73.6094Z",
    fill: "#EBEBEB"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6332 73.6094H36.2031V76.4597H37.6332V73.6094Z",
    fill: "#EBEBEB"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1723 73.6094H38.7422V76.4597H40.1723V73.6094Z",
    fill: "#EBEBEB"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7113 73.6094H41.2812V76.4597H42.7113V73.6094Z",
    fill: "#EBEBEB"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2426 73.6094H43.8125V76.4597H45.2426V73.6094Z",
    fill: "#EBEBEB"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M35.102 78.2344H33.6719V81.0847H35.102V78.2344Z",
    fill: "#EBEBEB"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6332 78.2344H36.2031V81.0847H37.6332V78.2344Z",
    fill: "#EBEBEB"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1723 78.2344H38.7422V81.0847H40.1723V78.2344Z",
    fill: "#EBEBEB"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7113 78.2344H41.2812V81.0847H42.7113V78.2344Z",
    fill: "#EBEBEB"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2426 78.2344H43.8125V81.0847H45.2426V78.2344Z",
    fill: "#EBEBEB"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M35.102 82.8672H33.6719V85.7175H35.102V82.8672Z",
    fill: "#EBEBEB"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6332 82.8672H36.2031V85.7175H37.6332V82.8672Z",
    fill: "#EBEBEB"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1723 82.8672H38.7422V85.7175H40.1723V82.8672Z",
    fill: "#EBEBEB"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7113 82.8672H41.2812V85.7175H42.7113V82.8672Z",
    fill: "#EBEBEB"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2426 82.8672H43.8125V85.7175H45.2426V82.8672Z",
    fill: "#EBEBEB"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M35.102 87.5H33.6719V90.3503H35.102V87.5Z",
    fill: "#EBEBEB"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6332 87.5H36.2031V90.3503H37.6332V87.5Z",
    fill: "#EBEBEB"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1723 87.5H38.7422V90.3503H40.1723V87.5Z",
    fill: "#EBEBEB"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7113 87.5H41.2812V90.3503H42.7113V87.5Z",
    fill: "#EBEBEB"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2426 87.5H43.8125V90.3503H45.2426V87.5Z",
    fill: "#EBEBEB"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M35.102 92.1328H33.6719V94.9831H35.102V92.1328Z",
    fill: "#EBEBEB"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6332 92.1328H36.2031V94.9831H37.6332V92.1328Z",
    fill: "#EBEBEB"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1723 92.1328H38.7422V94.9831H40.1723V92.1328Z",
    fill: "#EBEBEB"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7113 92.1328H41.2812V94.9831H42.7113V92.1328Z",
    fill: "#EBEBEB"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2426 92.1328H43.8125V94.9831H45.2426V92.1328Z",
    fill: "#EBEBEB"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M35.102 96.7656H33.6719V99.6159H35.102V96.7656Z",
    fill: "#EBEBEB"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6332 96.7656H36.2031V99.6159H37.6332V96.7656Z",
    fill: "#EBEBEB"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1723 96.7656H38.7422V99.6159H40.1723V96.7656Z",
    fill: "#EBEBEB"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7113 96.7656H41.2812V99.6159H42.7113V96.7656Z",
    fill: "#EBEBEB"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2426 96.7656H43.8125V99.6159H45.2426V96.7656Z",
    fill: "#EBEBEB"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M35.102 101.406H33.6719V104.257H35.102V101.406Z",
    fill: "#EBEBEB"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6332 101.406H36.2031V104.257H37.6332V101.406Z",
    fill: "#EBEBEB"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1723 101.406H38.7422V104.257H40.1723V101.406Z",
    fill: "#EBEBEB"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7113 101.406H41.2812V104.257H42.7113V101.406Z",
    fill: "#EBEBEB"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2426 101.406H43.8125V104.257H45.2426V101.406Z",
    fill: "#EBEBEB"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M35.102 106.031H33.6719V108.882H35.102V106.031Z",
    fill: "#EBEBEB"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6332 106.031H36.2031V108.882H37.6332V106.031Z",
    fill: "#EBEBEB"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1723 106.031H38.7422V108.882H40.1723V106.031Z",
    fill: "#EBEBEB"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7113 106.031H41.2812V108.882H42.7113V106.031Z",
    fill: "#EBEBEB"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2426 106.031H43.8125V108.882H45.2426V106.031Z",
    fill: "#EBEBEB"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M35.102 110.664H33.6719V112.442H35.102V110.664Z",
    fill: "#EBEBEB"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6332 110.664H36.2031V112.442H37.6332V110.664Z",
    fill: "#EBEBEB"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1723 110.664H38.7422V112.442H40.1723V110.664Z",
    fill: "#EBEBEB"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7113 110.664H41.2812V112.442H42.7113V110.664Z",
    fill: "#EBEBEB"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2426 110.664H43.8125V112.442H45.2426V110.664Z",
    fill: "#EBEBEB"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5894 46.4922H46.5234V112.44H55.5894V46.4922Z",
    fill: "#DBDBDB"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M55.983 45.0469H46.5234V46.4901H55.983V45.0469Z",
    fill: "#C7C7C7"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2348 48.625H47.8047V112.447H49.2348V48.625Z",
    fill: "#C7C7C7"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7582 48.625H50.3281V112.447H51.7582V48.625Z",
    fill: "#C7C7C7"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2973 48.625H52.8672V112.447H54.2973V48.625Z",
    fill: "#C7C7C7"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2348 50.4453H47.8047V53.2956H49.2348V50.4453Z",
    fill: "#DBDBDB"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7582 50.4453H50.3281V53.2956H51.7582V50.4453Z",
    fill: "#DBDBDB"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2973 50.4453H52.8672V53.2956H54.2973V50.4453Z",
    fill: "#DBDBDB"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2348 55.0781H47.8047V57.9284H49.2348V55.0781Z",
    fill: "#DBDBDB"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7582 55.0781H50.3281V57.9284H51.7582V55.0781Z",
    fill: "#DBDBDB"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2973 55.0781H52.8672V57.9284H54.2973V55.0781Z",
    fill: "#DBDBDB"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2348 59.7031H47.8047V62.5534H49.2348V59.7031Z",
    fill: "#DBDBDB"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7582 59.7031H50.3281V62.5534H51.7582V59.7031Z",
    fill: "#DBDBDB"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2973 59.7031H52.8672V62.5534H54.2973V59.7031Z",
    fill: "#DBDBDB"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2348 64.3438H47.8047V67.1941H49.2348V64.3438Z",
    fill: "#DBDBDB"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7582 64.3438H50.3281V67.1941H51.7582V64.3438Z",
    fill: "#DBDBDB"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2973 64.3438H52.8672V67.1941H54.2973V64.3438Z",
    fill: "#DBDBDB"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2348 68.9688H47.8047V71.8191H49.2348V68.9688Z",
    fill: "#DBDBDB"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7582 68.9688H50.3281V71.8191H51.7582V68.9688Z",
    fill: "#DBDBDB"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2973 68.9688H52.8672V71.8191H54.2973V68.9688Z",
    fill: "#DBDBDB"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2348 73.6094H47.8047V76.4597H49.2348V73.6094Z",
    fill: "#DBDBDB"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7582 73.6094H50.3281V76.4597H51.7582V73.6094Z",
    fill: "#DBDBDB"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2973 73.6094H52.8672V76.4597H54.2973V73.6094Z",
    fill: "#DBDBDB"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2348 78.2344H47.8047V81.0847H49.2348V78.2344Z",
    fill: "#DBDBDB"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7582 78.2344H50.3281V81.0847H51.7582V78.2344Z",
    fill: "#DBDBDB"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2973 78.2344H52.8672V81.0847H54.2973V78.2344Z",
    fill: "#DBDBDB"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2348 82.8672H47.8047V85.7175H49.2348V82.8672Z",
    fill: "#DBDBDB"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7582 82.8672H50.3281V85.7175H51.7582V82.8672Z",
    fill: "#DBDBDB"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2973 82.8672H52.8672V85.7175H54.2973V82.8672Z",
    fill: "#DBDBDB"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2348 87.5H47.8047V90.3503H49.2348V87.5Z",
    fill: "#DBDBDB"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7582 87.5H50.3281V90.3503H51.7582V87.5Z",
    fill: "#DBDBDB"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2973 87.5H52.8672V90.3503H54.2973V87.5Z",
    fill: "#DBDBDB"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2348 92.1328H47.8047V94.9831H49.2348V92.1328Z",
    fill: "#DBDBDB"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7582 92.1328H50.3281V94.9831H51.7582V92.1328Z",
    fill: "#DBDBDB"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2973 92.1328H52.8672V94.9831H54.2973V92.1328Z",
    fill: "#DBDBDB"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2348 96.7656H47.8047V99.6159H49.2348V96.7656Z",
    fill: "#DBDBDB"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7582 96.7656H50.3281V99.6159H51.7582V96.7656Z",
    fill: "#DBDBDB"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2973 96.7656H52.8672V99.6159H54.2973V96.7656Z",
    fill: "#DBDBDB"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2348 101.406H47.8047V104.257H49.2348V101.406Z",
    fill: "#DBDBDB"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7582 101.406H50.3281V104.257H51.7582V101.406Z",
    fill: "#DBDBDB"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2973 101.406H52.8672V104.257H54.2973V101.406Z",
    fill: "#DBDBDB"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2348 106.031H47.8047V108.882H49.2348V106.031Z",
    fill: "#DBDBDB"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7582 106.031H50.3281V108.882H51.7582V106.031Z",
    fill: "#DBDBDB"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2973 106.031H52.8672V108.882H54.2973V106.031Z",
    fill: "#DBDBDB"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2348 110.664H47.8047V112.442H49.2348V110.664Z",
    fill: "#DBDBDB"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7582 110.664H50.3281V112.442H51.7582V110.664Z",
    fill: "#DBDBDB"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2973 110.664H52.8672V112.442H54.2973V110.664Z",
    fill: "#DBDBDB"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7332 70.7344H14.6719V112.446H28.7332V70.7344Z",
    fill: "#EBEBEB"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7324 67.1875H16.6719V70.7233H28.7324V67.1875Z",
    fill: "#C7C7C7"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1891 72.5781H16.2109V112.443H27.1891V72.5781Z",
    fill: "#DBDBDB"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1891 76.375H16.2109V77.3164H27.1891V76.375Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1891 80.2812H16.2109V81.2226H27.1891V80.2812Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1891 84.1875H16.2109V85.1289H27.1891V84.1875Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1891 88.0859H16.2109V89.0273H27.1891V88.0859Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1891 91.9844H16.2109V92.9257H27.1891V91.9844Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1891 95.8906H16.2109V96.832H27.1891V95.8906Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1891 99.7969H16.2109V100.738H27.1891V99.7969Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1891 103.688H16.2109V104.629H27.1891V103.688Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1891 107.594H16.2109V108.535H27.1891V107.594Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1891 111.5H16.2109V112.441H27.1891V111.5Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5412 70.7344H28.7344V112.446H37.5412V70.7344Z",
    fill: "#DBDBDB"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2193 67.1875H28.7344V70.7233H36.2193V67.1875Z",
    fill: "#A6A6A6"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7185 72.5781H29.9453V112.443H36.7185V72.5781Z",
    fill: "#C7C7C7"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7185 76.375H29.9453V77.3164H36.7185V76.375Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7185 80.2812H29.9453V81.2226H36.7185V80.2812Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7185 84.1875H29.9453V85.1289H36.7185V84.1875Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7185 88.0859H29.9453V89.0273H36.7185V88.0859Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7185 91.9844H29.9453V92.9257H36.7185V91.9844Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7185 95.8906H29.9453V96.832H36.7185V95.8906Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7185 99.7969H29.9453V100.738H36.7185V99.7969Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7185 103.688H29.9453V104.629H36.7185V103.688Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7185 107.594H29.9453V108.535H36.7185V107.594Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7185 111.5H29.9453V112.441H36.7185V111.5Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3855 88.0156H53.5156V112.435H64.3855V88.0156Z",
    fill: "#DBDBDB"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1486 90.1406H55.2266V91.6363H57.1486V90.1406Z",
    fill: "#C7C7C7"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1486 93.3281H55.2266V94.8238H57.1486V93.3281Z",
    fill: "#C7C7C7"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1486 96.5234H55.2266V98.0191H57.1486V96.5234Z",
    fill: "#C7C7C7"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1486 99.7188H55.2266V101.214H57.1486V99.7188Z",
    fill: "#C7C7C7"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1486 102.922H55.2266V104.418H57.1486V102.922Z",
    fill: "#C7C7C7"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1486 106.109H55.2266V107.605H57.1486V106.109Z",
    fill: "#C7C7C7"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1486 109.305H55.2266V110.8H57.1486V109.305Z",
    fill: "#C7C7C7"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9097 90.1406H57.9844V91.6363H59.9097V90.1406Z",
    fill: "#C7C7C7"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9097 93.3281H57.9844V94.8238H59.9097V93.3281Z",
    fill: "#C7C7C7"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9097 96.5234H57.9844V98.0191H59.9097V96.5234Z",
    fill: "#C7C7C7"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9097 99.7188H57.9844V101.214H59.9097V99.7188Z",
    fill: "#C7C7C7"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9097 102.922H57.9844V104.418H59.9097V102.922Z",
    fill: "#C7C7C7"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9097 106.109H57.9844V107.605H59.9097V106.109Z",
    fill: "#C7C7C7"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9097 109.305H57.9844V110.8H59.9097V109.305Z",
    fill: "#C7C7C7"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6754 90.1406H60.75V91.6363H62.6754V90.1406Z",
    fill: "#C7C7C7"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6754 93.3281H60.75V94.8238H62.6754V93.3281Z",
    fill: "#C7C7C7"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6754 96.5234H60.75V98.0191H62.6754V96.5234Z",
    fill: "#C7C7C7"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6754 99.7188H60.75V101.214H62.6754V99.7188Z",
    fill: "#C7C7C7"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6754 102.922H60.75V104.418H62.6754V102.922Z",
    fill: "#C7C7C7"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6754 106.109H60.75V107.605H62.6754V106.109Z",
    fill: "#C7C7C7"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6754 109.305H60.75V110.8H62.6754V109.305Z",
    fill: "#C7C7C7"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0088 88.0156H64.3828V112.435H72.0088V88.0156Z",
    fill: "#A6A6A6"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M69.662 110.562H71.2266V109.067H69.662V110.562Z",
    fill: "#C7C7C7"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M69.662 107.375H71.2266V105.879H69.662V107.375Z",
    fill: "#C7C7C7"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M69.662 104.172H71.2266V102.676H69.662V104.172Z",
    fill: "#C7C7C7"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M69.662 100.977H71.2266V99.4809H69.662V100.977Z",
    fill: "#C7C7C7"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M69.662 97.7812H71.2266V96.2856H69.662V97.7812Z",
    fill: "#C7C7C7"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M69.662 94.5781H71.2266V93.0824H69.662V94.5781Z",
    fill: "#C7C7C7"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M69.662 91.3906H71.2266V89.8949H69.662V91.3906Z",
    fill: "#C7C7C7"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4198 110.562H68.9844V109.067H67.4198V110.562Z",
    fill: "#C7C7C7"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4198 107.375H68.9844V105.879H67.4198V107.375Z",
    fill: "#C7C7C7"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4198 104.172H68.9844V102.676H67.4198V104.172Z",
    fill: "#C7C7C7"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4198 100.977H68.9844V99.4809H67.4198V100.977Z",
    fill: "#C7C7C7"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4198 97.7812H68.9844V96.2856H67.4198V97.7812Z",
    fill: "#C7C7C7"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4198 94.5781H68.9844V93.0824H67.4198V94.5781Z",
    fill: "#C7C7C7"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4198 91.3906H68.9844V89.8949H67.4198V91.3906Z",
    fill: "#C7C7C7"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1698 110.562H66.7344V109.067H65.1698V110.562Z",
    fill: "#C7C7C7"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1698 107.375H66.7344V105.879H65.1698V107.375Z",
    fill: "#C7C7C7"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1698 104.172H66.7344V102.676H65.1698V104.172Z",
    fill: "#C7C7C7"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1698 100.977H66.7344V99.4809H65.1698V100.977Z",
    fill: "#C7C7C7"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1698 97.7812H66.7344V96.2856H65.1698V97.7812Z",
    fill: "#C7C7C7"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1698 94.5781H66.7344V93.0824H65.1698V94.5781Z",
    fill: "#C7C7C7"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1698 91.3906H66.7344V89.8949H65.1698V91.3906Z",
    fill: "#C7C7C7"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M137.746 60.0078H130.234V68.8802H137.746V60.0078Z",
    fill: "#DBDBDB"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M142.505 60.0078H137.742V69.2049H142.505V60.0078Z",
    fill: "#C7C7C7"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M142.82 63.9297H138.094V69.2105H142.82V63.9297Z",
    fill: "#DBDBDB"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M145.769 63.9297H142.82V69.2105H145.769V63.9297Z",
    fill: "#C7C7C7"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M139.502 68.3047H127.359V112.44H139.502V68.3047Z",
    fill: "#EBEBEB"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M132.56 70.2031H128.742V71.7644H132.56V70.2031Z",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M137.443 70.2031H133.625V71.7644H137.443V70.2031Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M132.56 72.8594H128.742V74.4207H132.56V72.8594Z",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M137.443 72.8594H133.625V74.4207H137.443V72.8594Z",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M132.56 75.5H128.742V77.0613H132.56V75.5Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M137.443 75.5H133.625V77.0613H137.443V75.5Z",
    fill: "white"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M132.56 78.1484H128.742V79.7097H132.56V78.1484Z",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M137.443 78.1484H133.625V79.7097H137.443V78.1484Z",
    fill: "white"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M132.56 80.7969H128.742V82.3582H132.56V80.7969Z",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M137.443 80.7969H133.625V82.3582H137.443V80.7969Z",
    fill: "white"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M132.56 83.4531H128.742V85.0144H132.56V83.4531Z",
    fill: "white"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M137.443 83.4531H133.625V85.0144H137.443V83.4531Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M132.56 86.1016H128.742V87.6628H132.56V86.1016Z",
    fill: "white"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M137.443 86.0938H133.625V87.655H137.443V86.0938Z",
    fill: "white"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M132.56 88.75H128.742V90.3113H132.56V88.75Z",
    fill: "white"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M137.443 88.75H133.625V90.3113H137.443V88.75Z",
    fill: "white"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M132.56 91.3906H128.742V92.9519H132.56V91.3906Z",
    fill: "white"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M137.443 91.3906H133.625V92.9519H137.443V91.3906Z",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M132.56 94.0469H128.742V95.6082H132.56V94.0469Z",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M137.443 94.0469H133.625V95.6082H137.443V94.0469Z",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M132.56 96.6953H128.742V98.2566H132.56V96.6953Z",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M137.443 96.6953H133.625V98.2566H137.443V96.6953Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M132.56 99.3438H128.742V100.905H132.56V99.3438Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M137.443 99.3438H133.625V100.905H137.443V99.3438Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M132.56 101.984H128.742V103.546H132.56V101.984Z",
    fill: "white"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M137.443 101.984H133.625V103.546H137.443V101.984Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M132.56 104.641H128.742V106.202H132.56V104.641Z",
    fill: "white"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M137.443 104.641H133.625V106.202H137.443V104.641Z",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M149.332 68.3047H139.492V112.44H149.332V68.3047Z",
    fill: "#C7C7C7"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M145.208 106.203H148.344V104.642H145.208V106.203Z",
    fill: "#EBEBEB"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M141.2 106.203H144.336V104.642H141.2V106.203Z",
    fill: "#EBEBEB"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M145.208 103.547H148.344V101.986H145.208V103.547Z",
    fill: "#EBEBEB"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M141.2 103.547H144.336V101.986H141.2V103.547Z",
    fill: "#EBEBEB"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M145.208 100.906H148.344V99.345H145.208V100.906Z",
    fill: "#EBEBEB"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M141.2 100.906H144.336V99.345H141.2V100.906Z",
    fill: "#EBEBEB"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M145.208 98.25H148.344V96.6887H145.208V98.25Z",
    fill: "#EBEBEB"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M141.2 98.25H144.336V96.6887H141.2V98.25Z",
    fill: "#EBEBEB"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M145.208 95.6016H148.344V94.0403H145.208V95.6016Z",
    fill: "#EBEBEB"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M141.2 95.6016H144.336V94.0403H141.2V95.6016Z",
    fill: "#EBEBEB"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M145.208 92.9531H148.344V91.3919H145.208V92.9531Z",
    fill: "#EBEBEB"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M141.2 92.9531H144.336V91.3919H141.2V92.9531Z",
    fill: "#EBEBEB"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M145.208 90.3125H148.344V88.7512H145.208V90.3125Z",
    fill: "#EBEBEB"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M141.2 90.3125H144.336V88.7512H141.2V90.3125Z",
    fill: "#EBEBEB"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M145.208 87.6562H148.344V86.095H145.208V87.6562Z",
    fill: "#EBEBEB"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M141.2 87.6562H144.336V86.095H141.2V87.6562Z",
    fill: "#EBEBEB"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M145.208 85.0078H148.344V83.4465H145.208V85.0078Z",
    fill: "#EBEBEB"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M141.2 85.0078H144.336V83.4465H141.2V85.0078Z",
    fill: "#EBEBEB"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M145.208 82.3594H148.344V80.7981H145.208V82.3594Z",
    fill: "#EBEBEB"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M141.2 82.3594H144.336V80.7981H141.2V82.3594Z",
    fill: "#EBEBEB"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M145.208 79.7109H148.344V78.1497H145.208V79.7109Z",
    fill: "#EBEBEB"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M141.2 79.7109H144.336V78.1497H141.2V79.7109Z",
    fill: "#EBEBEB"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M145.208 77.0625H148.344V75.5012H145.208V77.0625Z",
    fill: "#EBEBEB"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M141.2 77.0625H144.336V75.5012H141.2V77.0625Z",
    fill: "#EBEBEB"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M145.208 74.4062H148.344V72.845H145.208V74.4062Z",
    fill: "#EBEBEB"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M141.2 74.4062H144.336V72.845H141.2V74.4062Z",
    fill: "#EBEBEB"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M145.208 71.7656H148.344V70.2043H145.208V71.7656Z",
    fill: "#EBEBEB"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M141.2 71.7656H144.336V70.2043H141.2V71.7656Z",
    fill: "#EBEBEB"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6363 83.6797H81.3125V112.439H95.6363V83.6797Z",
    fill: "#C7C7C7"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0979 86.1719H83.5625V87.9332H86.0979V86.1719Z",
    fill: "#DBDBDB"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0979 89.9375H83.5625V91.6989H86.0979V89.9375Z",
    fill: "#DBDBDB"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0979 93.7031H83.5625V95.4645H86.0979V93.7031Z",
    fill: "#DBDBDB"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0979 97.4609H83.5625V99.2223H86.0979V97.4609Z",
    fill: "#DBDBDB"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0979 101.219H83.5625V102.98H86.0979V101.219Z",
    fill: "#DBDBDB"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0979 104.984H83.5625V106.746H86.0979V104.984Z",
    fill: "#DBDBDB"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0979 108.75H83.5625V110.511H86.0979V108.75Z",
    fill: "#DBDBDB"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7386 86.1719H87.2031V87.9332H89.7386V86.1719Z",
    fill: "#DBDBDB"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7386 89.9375H87.2031V91.6989H89.7386V89.9375Z",
    fill: "#DBDBDB"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7386 93.7031H87.2031V95.4645H89.7386V93.7031Z",
    fill: "#DBDBDB"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7386 97.4609H87.2031V99.2223H89.7386V97.4609Z",
    fill: "#DBDBDB"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7386 101.219H87.2031V102.98H89.7386V101.219Z",
    fill: "#DBDBDB"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7386 104.984H87.2031V106.746H89.7386V104.984Z",
    fill: "#DBDBDB"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7386 108.75H87.2031V110.511H89.7386V108.75Z",
    fill: "#DBDBDB"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3792 86.1719H90.8438V87.9332H93.3792V86.1719Z",
    fill: "#DBDBDB"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3792 89.9375H90.8438V91.6989H93.3792V89.9375Z",
    fill: "#DBDBDB"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3792 93.7031H90.8438V95.4645H93.3792V93.7031Z",
    fill: "#DBDBDB"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3792 97.4609H90.8438V99.2223H93.3792V97.4609Z",
    fill: "#DBDBDB"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3792 101.219H90.8438V102.98H93.3792V101.219Z",
    fill: "#DBDBDB"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3792 104.984H90.8438V106.746H93.3792V104.984Z",
    fill: "#DBDBDB"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3792 108.75H90.8438V110.511H93.3792V108.75Z",
    fill: "#DBDBDB"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6287 80.6875H86.0938V83.6854H95.6287V80.6875Z",
    fill: "#DBDBDB"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M95.631 78.8281H89.5859V80.6846H95.631V78.8281Z",
    fill: "#EBEBEB"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M105.683 83.6797H95.6328V112.439H105.683V83.6797Z",
    fill: "#A6A6A6"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M102.593 110.234H104.656V108.473H102.593V110.234Z",
    fill: "#C7C7C7"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M102.593 106.469H104.656V104.707H102.593V106.469Z",
    fill: "#C7C7C7"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M102.593 102.703H104.656V100.942H102.593V102.703Z",
    fill: "#C7C7C7"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M102.593 98.9375H104.656V97.1761H102.593V98.9375Z",
    fill: "#C7C7C7"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M102.593 95.1797H104.656V93.4183H102.593V95.1797Z",
    fill: "#C7C7C7"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M102.593 91.4141H104.656V89.6527H102.593V91.4141Z",
    fill: "#C7C7C7"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M102.593 87.6562H104.656V85.8949H102.593V87.6562Z",
    fill: "#C7C7C7"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6244 110.234H101.688V108.473H99.6244V110.234Z",
    fill: "#C7C7C7"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6244 106.469H101.688V104.707H99.6244V106.469Z",
    fill: "#C7C7C7"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6244 102.703H101.688V100.942H99.6244V102.703Z",
    fill: "#C7C7C7"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6244 98.9375H101.688V97.1761H99.6244V98.9375Z",
    fill: "#C7C7C7"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6244 95.1797H101.688V93.4183H99.6244V95.1797Z",
    fill: "#C7C7C7"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6244 91.4141H101.688V89.6527H99.6244V91.4141Z",
    fill: "#C7C7C7"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6244 87.6562H101.688V85.8949H99.6244V87.6562Z",
    fill: "#C7C7C7"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6634 110.234H98.7266V108.473H96.6634V110.234Z",
    fill: "#C7C7C7"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6634 106.469H98.7266V104.707H96.6634V106.469Z",
    fill: "#C7C7C7"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6634 102.703H98.7266V100.942H96.6634V102.703Z",
    fill: "#C7C7C7"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6634 98.9375H98.7266V97.1761H96.6634V98.9375Z",
    fill: "#C7C7C7"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6634 95.1797H98.7266V93.4183H96.6634V95.1797Z",
    fill: "#C7C7C7"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6634 91.4141H98.7266V89.6527H96.6634V91.4141Z",
    fill: "#C7C7C7"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6634 87.6562H98.7266V85.8949H96.6634V87.6562Z",
    fill: "#C7C7C7"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M104.161 80.6875H95.6328V83.6854H104.161V80.6875Z",
    fill: "#C7C7C7"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M100.254 78.8281H95.6328V80.6846H100.254V78.8281Z",
    fill: "#DBDBDB"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M82 152.734C116.35 152.734 144.195 150.471 144.195 147.679C144.195 144.888 116.35 142.625 82 142.625C47.6505 142.625 19.8047 144.888 19.8047 147.679C19.8047 150.471 47.6505 152.734 82 152.734Z",
    fill: "#EBEBEB"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8281 114.82L30.1203 114.742L47.4157 114.712L82 114.656L116.584 114.712L133.88 114.738L151.172 114.82L133.88 114.899L116.584 114.928L82 114.984L47.4157 114.928L30.1203 114.899L12.8281 114.82Z",
    fill: "#263238"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M150.435 112.438H13.5703V114.822H150.435V112.438Z",
    fill: "#C7C7C7"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1645 112.438C23.3788 113.218 23.3788 114.042 23.1645 114.822C23.0492 114.436 22.9939 114.034 23.0005 113.631C22.9951 113.227 23.0504 112.825 23.1645 112.438Z",
    fill: "#263238"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M33.856 112.438C33.9701 112.825 34.0254 113.227 34.02 113.631C34.0266 114.034 33.9713 114.436 33.856 114.822C33.6417 114.042 33.6417 113.218 33.856 112.438Z",
    fill: "#263238"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M44.563 112.438C44.7772 113.218 44.7772 114.042 44.563 114.822C44.4477 114.436 44.3924 114.034 44.399 113.631C44.3935 113.227 44.4488 112.825 44.563 112.438Z",
    fill: "#263238"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2544 112.438C55.3686 112.825 55.4239 113.227 55.4184 113.631C55.4251 114.034 55.3697 114.436 55.2544 114.822C55.0402 114.042 55.0402 113.218 55.2544 112.438Z",
    fill: "#263238"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9536 112.438C66.1679 113.218 66.1679 114.042 65.9536 114.822C65.8383 114.436 65.783 114.034 65.7896 113.631C65.7842 113.227 65.8395 112.825 65.9536 112.438Z",
    fill: "#263238"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6451 112.438C76.7592 112.825 76.8145 113.227 76.8091 113.631C76.8157 114.034 76.7604 114.436 76.6451 114.822C76.4308 114.042 76.4308 113.218 76.6451 112.438Z",
    fill: "#263238"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M87.352 112.438C87.5663 113.218 87.5663 114.042 87.352 114.822C87.2367 114.436 87.1814 114.034 87.188 113.631C87.1826 113.227 87.2379 112.825 87.352 112.438Z",
    fill: "#263238"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0513 112.438C98.1655 112.825 98.2207 113.227 98.2153 113.631C98.2219 114.034 98.1666 114.436 98.0513 114.822C97.8371 114.042 97.8371 113.218 98.0513 112.438Z",
    fill: "#263238"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M108.743 112.438C108.957 113.218 108.957 114.042 108.743 114.822C108.627 114.436 108.572 114.034 108.579 113.631C108.573 113.227 108.629 112.825 108.743 112.438Z",
    fill: "#263238"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M119.434 112.438C119.548 112.825 119.604 113.227 119.598 113.631C119.605 114.034 119.549 114.436 119.434 114.822C119.22 114.042 119.22 113.218 119.434 112.438Z",
    fill: "#263238"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M130.141 112.438C130.355 113.218 130.355 114.042 130.141 114.822C130.026 114.436 129.97 114.034 129.977 113.631C129.972 113.227 130.027 112.825 130.141 112.438Z",
    fill: "#263238"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M140.84 112.438C140.955 112.825 141.01 113.227 141.004 113.631C141.011 114.034 140.956 114.436 140.84 114.822C140.626 114.042 140.626 113.218 140.84 112.438Z",
    fill: "#263238"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M28.998 112.433C28.998 112.433 28.7225 111.144 28.1715 110.947C27.6205 110.75 27.2826 111.328 27.2826 111.328C27.2826 111.328 27.1547 110.094 26.3708 109.727C25.5869 109.36 25.003 110.114 25.003 110.114C25.003 110.114 24.4028 108.562 23.3302 108.562C22.2576 108.562 21.7197 110.858 21.7197 110.858C21.7197 110.858 21.0867 110.18 20.4373 110.563C19.7878 110.947 19.7812 112.456 19.7812 112.456L28.998 112.433Z",
    fill: "#37474F"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M120.452 112.433C120.452 112.433 120.177 111.144 119.626 110.947C119.075 110.75 118.74 111.328 118.74 111.328C118.74 111.328 118.609 110.094 117.828 109.727C117.048 109.36 116.461 110.114 116.461 110.114C116.461 110.114 115.86 108.562 114.791 108.562C113.722 108.562 113.177 110.858 113.177 110.858C113.177 110.858 112.548 110.18 111.898 110.563C111.249 110.947 111.242 112.456 111.242 112.456L120.452 112.433Z",
    fill: "#455A64"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3565 112.433H43.6641C43.6641 112.433 43.9921 111.068 44.6251 110.97C44.8214 110.95 45.019 110.992 45.1905 111.09C45.362 111.187 45.4991 111.336 45.5829 111.514C45.5829 111.514 45.5533 109.609 46.7538 109.284C47.9543 108.959 48.958 110.642 48.958 110.642C48.958 110.642 49.7124 109.681 50.7357 109.743C51.7591 109.805 52.0248 111.383 52.0248 111.383C52.0248 111.383 52.9432 110.835 53.3565 112.433Z",
    fill: "#37474F"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3816 112.43H15.2812C15.2812 112.43 15.2812 111.673 15.7929 111.469C15.9293 111.411 16.0811 111.398 16.2254 111.433C16.3697 111.468 16.4988 111.548 16.5932 111.663C16.5932 111.663 16.7966 110.266 17.7314 110.266C18.6662 110.266 19.1156 111.469 19.1156 111.469C19.1949 111.354 19.3061 111.265 19.4355 111.213C19.5649 111.16 19.7068 111.147 19.8437 111.174C20.362 111.24 20.3816 112.43 20.3816 112.43Z",
    fill: "#455A64"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3582 112.43H52.2578C52.2578 112.43 52.2578 111.673 52.7695 111.469C52.9059 111.411 53.0576 111.398 53.2019 111.433C53.3463 111.468 53.4754 111.548 53.5698 111.663C53.5698 111.663 53.7765 110.266 54.7113 110.266C55.6461 110.266 56.0921 111.469 56.0921 111.469C56.1714 111.354 56.2826 111.265 56.412 111.213C56.5414 111.16 56.6834 111.147 56.8203 111.174C57.3385 111.24 57.3582 112.43 57.3582 112.43Z",
    fill: "#455A64"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M141.264 112.43H136.164C136.164 112.43 136.164 111.673 136.676 111.469C136.812 111.411 136.964 111.398 137.108 111.433C137.253 111.468 137.382 111.548 137.476 111.663C137.476 111.663 137.679 110.266 138.614 110.266C139.549 110.266 139.998 111.469 139.998 111.469C140.077 111.354 140.189 111.265 140.318 111.212C140.448 111.16 140.59 111.146 140.727 111.174C141.245 111.24 141.264 112.43 141.264 112.43Z",
    fill: "#455A64"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M148.707 112.435H140.297C140.297 112.435 140.317 111.182 141.143 110.851C141.368 110.756 141.617 110.737 141.854 110.796C142.09 110.856 142.301 110.99 142.455 111.179C142.455 111.179 142.783 108.883 144.335 108.883C145.886 108.883 146.611 110.861 146.611 110.861C146.742 110.671 146.925 110.524 147.138 110.437C147.351 110.35 147.585 110.327 147.811 110.372C148.674 110.474 148.707 112.435 148.707 112.435Z",
    fill: "#37474F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.272 54.968C139.272 55.2724 139.182 55.5699 139.012 55.823C138.843 56.076 138.603 56.2732 138.322 56.3895C138.04 56.5059 137.731 56.5362 137.432 56.4765C137.134 56.4169 136.86 56.2701 136.645 56.0546C136.43 55.8391 136.283 55.5647 136.224 55.2661C136.165 54.9675 136.196 54.6581 136.313 54.377C136.43 54.096 136.628 53.856 136.881 53.6874C137.135 53.5187 137.433 53.429 137.737 53.4297C137.939 53.4297 138.139 53.4695 138.325 53.5469C138.512 53.6242 138.681 53.7376 138.824 53.8805C138.966 54.0233 139.079 54.193 139.156 54.3796C139.233 54.5662 139.272 54.7662 139.272 54.968Z",
    fill: "#F34F42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.742 57.5761C137.222 57.5793 136.712 57.4278 136.278 57.1407C135.844 56.8536 135.505 56.444 135.304 55.9638C135.104 55.4837 135.05 54.9547 135.151 54.4442C135.252 53.9337 135.502 53.4646 135.87 53.0967C136.238 52.7287 136.707 52.4785 137.218 52.3778C137.728 52.277 138.257 52.3304 138.737 52.531C139.217 52.7316 139.627 53.0705 139.914 53.5045C140.201 53.9385 140.353 54.4481 140.35 54.9685C140.345 55.6587 140.069 56.3195 139.581 56.8076C139.093 57.2957 138.432 57.5718 137.742 57.5761ZM137.742 52.6889C137.292 52.6889 136.852 52.8222 136.477 53.0719C136.103 53.3217 135.81 53.6768 135.637 54.0924C135.464 54.508 135.418 54.9655 135.505 55.4072C135.592 55.849 135.807 56.2552 136.124 56.5746C136.441 56.8941 136.846 57.1125 137.287 57.2023C137.728 57.2921 138.186 57.2492 138.603 57.0792C139.02 56.9092 139.377 56.6196 139.629 56.2469C139.882 55.8741 140.018 55.435 140.022 54.9849C140.024 54.6841 139.966 54.3859 139.853 54.1075C139.739 53.829 139.572 53.5758 139.36 53.3623C139.148 53.1489 138.896 52.9795 138.618 52.864C138.34 52.7484 138.043 52.6889 137.742 52.6889Z",
    fill: "#F34F42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2094 40.2694C45.2101 40.5738 45.1204 40.8715 44.9518 41.125C44.7832 41.3784 44.5431 41.576 44.2621 41.693C43.9811 41.8099 43.6717 41.8408 43.373 41.7819C43.0744 41.7229 42.8 41.5766 42.5845 41.3616C42.3691 41.1466 42.2222 40.8725 42.1626 40.574C42.103 40.2755 42.1333 39.966 42.2496 39.6848C42.3659 39.4035 42.5631 39.163 42.8161 38.9939C43.0692 38.8247 43.3667 38.7344 43.6711 38.7344C44.0785 38.7344 44.4693 38.896 44.7577 39.1838C45.0461 39.4716 45.2086 39.862 45.2094 40.2694Z",
    fill: "#F34F42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6716 42.8729C43.152 42.8762 42.6431 42.7251 42.2094 42.4387C41.7757 42.1524 41.4369 41.7437 41.2357 41.2645C41.0346 40.7853 40.9803 40.2572 41.0797 39.7472C41.1791 39.2371 41.4277 38.768 41.794 38.3994C42.1603 38.0308 42.6278 37.7792 43.1373 37.6766C43.6467 37.5741 44.1752 37.625 44.6556 37.8232C45.136 38.0213 45.5468 38.3576 45.8359 38.7894C46.1249 39.2213 46.2792 39.7293 46.2793 40.2489C46.2793 40.942 46.0051 41.607 45.5165 42.0986C45.028 42.5902 44.3647 42.8686 43.6716 42.8729ZM43.6716 37.9825C43.2162 37.9792 42.77 38.1115 42.3899 38.3626C42.0098 38.6136 41.713 38.972 41.5372 39.3922C41.3614 39.8124 41.3146 40.2754 41.4026 40.7223C41.4907 41.1692 41.7097 41.5798 42.0318 41.9019C42.3539 42.224 42.7645 42.443 43.2114 42.5311C43.6583 42.6192 44.1213 42.5723 44.5415 42.3965C44.9617 42.2207 45.3201 41.9239 45.5711 41.5438C45.8222 41.1637 45.9545 40.7176 45.9513 40.2621C45.947 39.6588 45.7054 39.0815 45.2788 38.6549C44.8522 38.2283 44.2749 37.9868 43.6716 37.9825Z",
    fill: "#F34F42"
  }))), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1396 24.2762C48.8674 21.5472 46.9846 18.8281 43.6784 18.8281C40.3722 18.8281 38.4927 21.5604 38.2205 24.2762C37.8039 28.491 40.6444 32.3089 43.6784 35.7923C46.7124 32.322 49.5562 28.5041 49.1396 24.2762ZM43.6784 27.3069C43.0866 27.3069 42.5082 27.1314 42.0162 26.8026C41.5242 26.4737 41.1407 26.0063 40.9144 25.4595C40.6881 24.9128 40.6291 24.3111 40.7448 23.7308C40.8605 23.1504 41.1457 22.6174 41.5644 22.1992C41.983 21.781 42.5163 21.4963 43.0968 21.3813C43.6773 21.2662 44.2789 21.3259 44.8254 21.5529C45.372 21.7798 45.8389 22.1637 46.1672 22.656C46.4955 23.1484 46.6704 23.7271 46.6698 24.3188C46.6715 24.7126 46.5954 25.1029 46.4458 25.4671C46.2962 25.8314 46.0761 26.1625 45.7981 26.4414C45.5201 26.7203 45.1897 26.9415 44.8259 27.0923C44.4622 27.2431 44.0722 27.3205 43.6784 27.32V27.3069Z",
    fill: "#F34F42"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M101.065 62.9684L93.0192 45.6926C92.7023 45.0124 92.2463 44.4062 91.6806 43.9132C91.1149 43.4201 90.4521 43.0512 89.7349 42.8301L49.8667 30.5529C49.1893 30.3442 48.4773 30.2717 47.7717 30.3399C47.0662 30.408 46.3812 30.6153 45.7562 30.9498C45.1313 31.2843 44.5789 31.7393 44.1309 32.2886C43.6829 32.8379 43.3483 33.4705 43.1463 34.1499L34.7251 62.4622C34.5239 63.1382 34.4579 63.8472 34.531 64.5487C34.6041 65.2502 34.8149 65.9303 35.1512 66.5503C35.4876 67.1702 35.9429 67.7177 36.4911 68.1614C37.0393 68.6051 37.6696 68.9364 38.346 69.1362L78.213 80.915C78.9489 81.1339 79.7233 81.1921 80.4837 81.0858C81.244 80.9795 81.9727 80.7111 82.6204 80.2988L99.0896 69.7631C100.187 69.0627 100.992 67.9873 101.355 66.7373C101.719 65.4873 101.616 64.1479 101.065 62.9684ZM92.8366 65.8571C92.288 66.539 91.5496 67.0428 90.7147 67.305C89.8798 67.5672 88.9859 67.5759 88.1461 67.33C87.3062 67.0841 86.5582 66.5947 85.9965 65.9237C85.4348 65.2527 85.0847 64.4301 84.9905 63.5601C84.8963 62.6901 85.0622 61.8117 85.4672 61.036C85.8722 60.2602 86.4982 59.6221 87.266 59.2021C88.0337 58.7822 88.9088 58.5993 89.7804 58.6767C90.6521 58.7541 91.4813 59.0882 92.163 59.6369C93.0753 60.372 93.6588 61.4389 93.7855 62.6036C93.9121 63.7684 93.5717 64.9358 92.8387 65.8498L92.8366 65.8571Z",
    fill: "#FF725E"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.065 62.9684L93.0192 45.6926C92.7023 45.0124 92.2463 44.4062 91.6806 43.9132C91.1149 43.4201 90.4521 43.0512 89.7349 42.8301L49.8667 30.5529C49.1893 30.3442 48.4773 30.2717 47.7717 30.3399C47.0662 30.408 46.3812 30.6153 45.7562 30.9498C45.1313 31.2843 44.5789 31.7393 44.1309 32.2886C43.6829 32.8379 43.3483 33.4705 43.1463 34.1499L34.7251 62.4622C34.5239 63.1382 34.4579 63.8472 34.531 64.5487C34.6041 65.2502 34.8149 65.9303 35.1512 66.5503C35.4876 67.1702 35.9429 67.7177 36.4911 68.1614C37.0393 68.6051 37.6696 68.9364 38.346 69.1362L78.213 80.915C78.9489 81.1339 79.7233 81.1921 80.4837 81.0858C81.244 80.9795 81.9727 80.7111 82.6204 80.2988L99.0896 69.7631C100.187 69.0627 100.992 67.9873 101.355 66.7373C101.719 65.4873 101.616 64.1479 101.065 62.9684ZM92.8366 65.8571C92.288 66.539 91.5496 67.0428 90.7147 67.305C89.8798 67.5672 88.9859 67.5759 88.1461 67.33C87.3062 67.0841 86.5582 66.5947 85.9965 65.9237C85.4348 65.2527 85.0847 64.4301 84.9905 63.5601C84.8963 62.6901 85.0622 61.8117 85.4672 61.036C85.8722 60.2602 86.4982 59.6221 87.266 59.2021C88.0337 58.7822 88.9088 58.5993 89.7804 58.6767C90.6521 58.7541 91.4813 59.0882 92.163 59.6369C93.0753 60.372 93.6588 61.4389 93.7855 62.6036C93.9121 63.7684 93.5717 64.9358 92.8387 65.8498L92.8366 65.8571Z",
    fill: "black"
  }))), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M103.164 63.599L95.1129 46.3215C94.7958 45.6414 94.3398 45.0354 93.7741 44.5423C93.2084 44.0493 92.5457 43.6803 91.8287 43.4591L51.9604 31.1818C51.283 30.9728 50.571 30.9002 49.8653 30.9682C49.1597 31.0362 48.4746 31.2435 47.8496 31.578C47.2246 31.9125 46.6722 32.3677 46.2243 32.9171C45.7763 33.4665 45.4418 34.0993 45.24 34.7789L36.817 63.0906C36.6156 63.7681 36.55 64.4787 36.624 65.1817C36.698 65.8846 36.9102 66.566 37.2483 67.1867C37.5865 67.8073 38.044 68.3551 38.5945 68.7984C39.145 69.2418 39.7776 69.572 40.4561 69.77L80.3213 81.5483C81.0573 81.7669 81.8316 81.825 82.5919 81.7187C83.3522 81.6124 84.0809 81.3441 84.7287 80.9321L101.196 70.3958C102.293 69.6945 103.097 68.6183 103.459 67.3678C103.821 66.1173 103.716 64.7778 103.164 63.599ZM94.9376 66.4882C94.3891 67.1701 93.6507 67.6739 92.8158 67.9361C91.9809 68.1983 91.087 68.207 90.2471 67.9611C89.4073 67.7152 88.6592 67.2258 88.0975 66.5548C87.5358 65.8838 87.1857 65.0612 87.0915 64.1912C86.9973 63.3212 87.1632 62.4428 87.5682 61.6671C87.9733 60.8913 88.5993 60.2532 89.367 59.8332C90.1348 59.4133 91.0098 59.2304 91.8815 59.3078C92.7531 59.3852 93.5823 59.7193 94.2641 60.268C95.1763 61.0031 95.7598 62.07 95.8865 63.2347C96.0132 64.3995 95.6727 65.5669 94.9398 66.4809L94.9376 66.4882Z",
    fill: "#FF725E"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6755 48.3175C56.7354 44.8972 59.4972 43.3705 62.452 44.2888C65.4068 45.2071 66.8006 47.9885 65.7325 51.4361C64.6643 54.8837 61.9363 56.3907 58.9827 55.4747C56.0292 54.5588 54.6138 51.7372 55.6755 48.3175ZM62.833 50.5384C63.5084 48.3599 62.9916 47.06 61.7152 46.6651C60.4703 46.2777 59.2673 47.0795 58.6017 49.2252C57.9361 51.3709 58.4746 52.711 59.7195 53.0984C60.996 53.4933 62.1592 52.7113 62.833 50.5384ZM74.4634 48.2736L77.9123 49.3441L57.7694 65.3255L54.3205 64.255L74.4634 48.2736ZM66.5005 62.169C67.5623 58.7493 70.3222 57.2221 73.2502 58.1304C76.2051 59.0487 77.6169 61.8692 76.5575 65.2876C75.4981 68.7061 72.7385 70.2255 69.7825 69.3048C66.8642 68.4035 65.4433 65.5802 66.5005 62.169ZM73.6294 64.3794C74.2945 62.2355 73.7875 60.9028 72.5111 60.5079C71.2662 60.1205 70.0738 60.8938 69.3995 63.0686C68.7251 65.2434 69.2705 66.5539 70.5154 66.9413C71.794 67.3289 72.9666 66.5159 73.6303 64.3697L73.6294 64.3794Z",
    fill: "white"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3144 71.617C99.4362 71.7377 99.5414 71.874 99.6273 72.0224C99.8171 72.2956 100.092 72.7034 100.434 73.2366C100.776 73.7698 101.19 74.4259 101.643 75.2028C102.097 75.9798 102.597 76.878 103.083 77.9107C103.621 79.0333 104.063 80.1995 104.404 81.3966L104.539 81.8873L104.653 82.392C104.735 82.7379 104.799 83.0881 104.843 83.4409C104.951 84.1933 104.913 84.9594 104.733 85.6978C104.628 86.0898 104.455 86.4604 104.222 86.7925C103.98 87.1356 103.67 87.4255 103.312 87.6444C102.579 88.0864 101.725 88.2845 100.872 88.2101C100.01 88.1268 99.1759 87.8551 98.4301 87.414C97.6796 86.9756 96.9826 86.4515 96.3529 85.8523C95.1168 84.6702 94.0885 83.2884 93.3112 81.7649C92.9377 81.0484 92.6087 80.3095 92.3261 79.5525C92.0493 78.8173 91.7934 78.0917 91.5585 77.3757C90.6302 74.5177 90.0386 71.8599 89.8483 69.5844C89.8004 69.0165 89.7739 68.4767 89.7655 67.9623C89.7631 67.7056 89.7628 67.4555 89.7746 67.211C89.7785 66.9724 89.8015 66.7344 89.8433 66.4994C89.9091 66.0497 90.1485 65.6436 90.5101 65.3681C90.8154 65.1515 91.179 65.0324 91.5532 65.0263C91.7082 65.022 91.8633 65.032 92.0165 65.0561C92.15 65.0812 92.2812 65.1173 92.4088 65.1639C92.6095 65.2348 92.7969 65.3386 92.9634 65.4712C93.064 65.5539 93.1512 65.6516 93.2217 65.761C93.2667 65.836 93.2847 65.8752 93.2771 65.8808C93.2694 65.8864 93.2372 65.855 93.1806 65.7923C93.0986 65.701 93.0055 65.6204 92.9034 65.5524C92.737 65.4422 92.5548 65.3581 92.3631 65.303C92.2408 65.2676 92.1163 65.2409 91.9903 65.2229C91.8477 65.2086 91.7042 65.2067 91.5614 65.2172C91.231 65.2373 90.914 65.3549 90.6505 65.5551C90.3493 65.8023 90.1571 66.1579 90.1152 66.5453C90.0811 66.7684 90.0652 66.9939 90.0677 67.2196C90.0622 67.4561 90.0702 67.7005 90.0779 67.9528C90.0992 68.4593 90.1378 68.992 90.1936 69.5511C90.4229 71.7827 91.0394 74.4103 91.9865 77.2323C92.2243 77.9386 92.4833 78.6559 92.7635 79.3842C93.0439 80.1224 93.3692 80.8429 93.7374 81.5415C94.4943 83.0144 95.4906 84.3513 96.6855 85.4977C97.2897 86.0717 97.9577 86.5744 98.6766 86.9959C99.3599 87.4027 100.124 87.6556 100.915 87.7368C101.666 87.8049 102.419 87.6353 103.068 87.252C103.677 86.8746 104.117 86.278 104.299 85.5853C104.466 84.9003 104.502 84.1897 104.403 83.4915C104.364 83.1515 104.307 82.8138 104.232 82.4799L104.131 81.9911L104.007 81.5054C103.686 80.3242 103.27 79.1713 102.761 78.0581C102.303 77.0318 101.83 76.128 101.394 75.3384C100.959 74.5489 100.577 73.8828 100.259 73.3369L99.5401 72.0816C99.4459 71.9366 99.3701 71.7806 99.3144 71.617Z",
    fill: "#263238"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2289 48.7916L88.6164 48.4658L89.6081 47.4419L89.9358 48.8299L90.9591 49.8235L89.5716 50.1493L88.5781 51.1727L88.2523 49.7852L87.2289 48.7916Z",
    fill: "white"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3989 44.9927L81.8854 44.8787L82.233 44.5207L82.3475 45.0055L82.7055 45.353L82.2189 45.4669L81.8714 45.825L81.7569 45.3402L81.3989 44.9927Z",
    fill: "white"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9749 54.5804L83.914 54.3601L84.5863 53.6669L84.8065 54.6061L85.4997 55.2784L84.5606 55.4986L83.8883 56.1918L83.6681 55.2527L82.9749 54.5804Z",
    fill: "white"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3995 126.297H58.6016V130.256H94.3995V126.297Z",
    fill: "#F34F42"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1406 91.5625H29.1709L42.2909 106.572H40.2606L27.1406 91.5625Z",
    fill: "#A6A6A6"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7146 90.375H24.5V91.5624H52.7146V90.375Z",
    fill: "#A6A6A6"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8047 91.5625H36.835L49.955 106.572H47.9247L34.8047 91.5625Z",
    fill: "#A6A6A6"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8559 119.234C58.0502 119.234 63.9575 126.316 63.9575 134.65C63.9575 142.985 58.4864 149.906 48.5447 149.906C37.5436 149.906 32.2891 141.155 32.2891 134.575C32.2891 127.995 37.5371 119.234 47.8559 119.234Z",
    fill: "#37474F"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2837 119.234C55.9761 119.234 61.5882 126.316 61.5882 134.65C61.5882 142.985 56.3894 149.906 46.9332 149.906C36.4733 149.906 31.4844 141.141 31.4844 134.562C31.4844 127.982 36.4733 119.234 46.2837 119.234Z",
    fill: "#263238"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3905 125.219C52.2945 125.219 55.7155 129.535 55.7155 134.613C55.7155 139.69 52.547 143.905 46.7873 143.905C40.411 143.905 37.3672 138.572 37.3672 134.56C37.3672 130.549 40.411 125.219 46.3905 125.219Z",
    fill: "#C7C7C7"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7131 100.545V99.2031L42.4075 100.308V103.326C42.4075 103.326 32.4724 114.298 31.4688 125.702L65.8694 126.43L71.3962 126.293H78.1825V119.398C78.1825 119.398 73.0526 115.659 73.9513 108.02C74.2498 105.484 76.7131 100.545 76.7131 100.545Z",
    fill: "#F34F42"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6658 124.826C62.3083 125.482 57.0898 126.423 47.1973 126.689C38.2921 126.928 31.6403 126.732 31.1253 126.158C30.6104 125.584 31.9224 115.432 37.951 109.935C43.9796 104.437 52.5142 103.647 58.1427 106.927C63.0922 109.803 66.7855 117.115 62.6658 124.826Z",
    fill: "#F34F42"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M64.3386 115.224C63.8097 112.82 62.5898 110.623 60.829 108.903C59.0638 107.135 56.8596 105.868 54.4428 105.233C51.747 104.56 48.9235 104.591 46.2428 105.322C44.9012 105.673 43.6039 106.176 42.3757 106.821C41.0789 107.517 39.8568 108.345 38.7283 109.29C38.4266 109.54 38.1215 109.789 37.8231 110.045C37.7968 110.065 37.8231 110.101 37.8624 110.081C38.9978 109.083 40.2269 108.196 41.5327 107.434C42.7243 106.753 43.9884 106.209 45.3015 105.81C47.9047 104.996 50.6692 104.841 53.3473 105.358C55.7677 105.844 58.011 106.978 59.8384 108.638C61.5993 110.223 62.8943 112.259 63.5842 114.525C64.4042 117.287 64.1352 120.328 63.3185 123.053C63.2103 123.421 63.0922 123.782 62.9708 124.142C62.9708 124.182 63.0167 124.195 63.0299 124.159C64.1319 121.328 64.9552 118.278 64.3386 115.224Z",
    fill: "black"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4965 127.741C34.5237 127.741 31.3617 127.557 29.7578 126.921L30.5024 125.048C32.3785 125.792 38.253 125.779 47.706 125.671C54.6891 125.589 59.842 124.93 63.0564 123.703L63.7747 125.586C60.2979 126.898 55.0499 127.593 47.7289 127.678C44.9508 127.718 42.5564 127.741 40.4965 127.741Z",
    fill: "#DBDBDB"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2721 100.084C77.2721 100.084 77.5017 92.5795 77.2721 92.2843C77.0425 91.9891 42.3139 91.3626 41.2741 91.4544C40.2343 91.5463 40.1294 100.31 40.2081 100.72C40.2868 101.13 76.3668 100.163 77.2721 100.084Z",
    fill: "#37474F"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5356 92.4368C80.4339 92.3187 76.0322 92.1941 75.7894 92.1875C75.5467 92.1809 75.4614 100.181 75.5926 100.174C75.7238 100.168 80.3749 100.233 80.529 100.063C80.6832 99.8922 80.7554 92.6926 80.5356 92.4368Z",
    fill: "#455A64"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2083 91.4688C56.0838 91.5984 56.0025 91.7634 55.9754 91.9411C55.9342 92.1282 55.9046 92.3177 55.8868 92.5085C55.8442 92.889 55.8212 93.276 55.8015 93.6598C55.7687 94.4339 55.7491 95.2112 55.7359 95.9919C55.7228 96.7725 55.7031 97.5466 55.7359 98.3174C55.7389 98.6991 55.7651 99.0803 55.8147 99.4588C55.8344 99.6418 55.8774 99.8214 55.9426 99.9935C55.9666 100.071 56.009 100.141 56.0661 100.198C56.1233 100.255 56.1934 100.297 56.2706 100.321C56.184 100.319 56.1 100.292 56.0285 100.243C55.957 100.194 55.901 100.126 55.8671 100.046C55.7754 99.8744 55.7038 99.6928 55.6539 99.5047C55.5611 99.1202 55.5008 98.7285 55.4735 98.3338C55.413 97.5482 55.3933 96.7599 55.4145 95.9722C55.4342 95.1883 55.467 94.4011 55.5555 93.6172C55.5981 93.225 55.6605 92.8353 55.7425 92.4495C55.7883 92.2586 55.8441 92.0703 55.9098 91.8853C55.9623 91.7246 56.0541 91.5245 56.2083 91.4688Z",
    fill: "#455A64"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8048 90.3516H58.6016V69.9631H25.8048V90.3516Z",
    fill: "#37474F"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8053 90.3516H49.5V69.9631H25.8053L25.8053 90.3516Z",
    fill: "#263238"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9314 69.9688H36.3828V90.3572H38.9314V69.9688Z",
    fill: "#F34F42"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5045 68.0781H25.1406V69.9641H49.5045V68.0781Z",
    fill: "#37474F"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3367 68.0781H49.5V69.9641H59.3367V68.0781Z",
    fill: "#263238"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1423 68.0781H36.1641V69.9641H39.1423V68.0781Z",
    fill: "#F34F42"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M122.73 119.109C132.927 119.109 138.831 126.191 138.831 134.525C138.831 142.86 133.36 149.771 123.415 149.771C112.411 149.771 107.156 141.02 107.156 134.443C107.156 127.867 112.411 119.109 122.73 119.109Z",
    fill: "#37474F"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M121.162 119.109C130.854 119.109 136.47 126.191 136.47 134.525C136.47 142.86 131.268 149.771 121.815 149.771C111.355 149.771 106.359 141.02 106.359 134.443C106.359 127.867 111.355 119.109 121.162 119.109Z",
    fill: "#263238"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M121.262 125.094C127.166 125.094 130.591 129.41 130.591 134.488C130.591 139.565 127.422 143.78 121.659 143.78C115.286 143.78 112.242 138.447 112.242 134.438C112.242 130.43 115.286 125.094 121.262 125.094Z",
    fill: "#C7C7C7"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M106.237 84.2844H102.225L99.4766 80.25H104.177L106.237 84.2844Z",
    fill: "#F34F42"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4766 80.25L101.087 82.6116L102.225 84.2844H106.237L105.151 82.159L104.174 80.25H99.4766Z",
    fill: "#F34F42"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M99.4766 80.25L101.087 82.6116L105.151 82.159L104.174 80.25H99.4766Z",
    fill: "black"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M115.98 114.392L112.074 115.291L108.492 111.971L113.071 110.922L115.98 114.392Z",
    fill: "#F34F42"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M108.492 111.971L110.588 113.917L112.071 115.291L115.984 114.392L114.449 112.565L113.071 110.922L108.492 111.971Z",
    fill: "#F34F42"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M108.492 111.971L110.588 113.917L114.449 112.565L113.071 110.922L108.492 111.971Z",
    fill: "black"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M137.942 121.079L134.147 123.073C134.147 123.073 123.156 121.079 116.107 122.587C109.058 124.096 107.156 127.862 107.156 127.862H103.594C103.594 127.862 106.651 117.002 111.836 113.059C117.022 109.116 125.357 109.999 129.965 112.482C134.573 114.965 137.942 121.079 137.942 121.079Z",
    fill: "#F34F42"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M133.752 122.323C133.017 121.555 132.22 120.849 131.371 120.211C130.529 119.556 129.638 118.966 128.707 118.446C126.903 117.443 124.923 116.793 122.876 116.53C118.867 116.038 114.676 117.206 111.724 120.286C110.064 122.031 108.883 124.173 107.761 126.334C107.745 126.367 107.791 126.393 107.807 126.361C108.758 124.46 109.958 122.695 111.376 121.113C112.742 119.621 114.443 118.474 116.338 117.767C120.12 116.38 124.21 116.911 127.845 118.587C128.885 119.059 129.89 119.607 130.849 120.227C131.831 120.888 132.778 121.598 133.686 122.356C133.692 122.361 133.7 122.364 133.707 122.366C133.715 122.367 133.723 122.365 133.73 122.362C133.738 122.358 133.743 122.353 133.747 122.346C133.751 122.339 133.753 122.331 133.752 122.323Z",
    fill: "black"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0431 82.1209C91.9841 82.2587 84.0629 83.715 84.0629 83.715C84.0629 83.715 82.7509 82.8294 83.561 81.7076L91.5085 79.9922C91.814 80.2428 92.0309 80.585 92.1271 80.9683C92.2234 81.3516 92.1939 81.7556 92.0431 82.1209Z",
    fill: "#263238"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M108.67 71.8774V81.2746C108.67 81.2746 103.596 80.8318 102.245 80.7858C100.893 80.7399 94.8876 81.5173 94.8876 81.5173L94.4219 79.4115C94.4219 79.4115 99.0532 77.7945 101.021 76.5317C102.989 75.2689 105.256 72.8548 106.473 72.3202C107.161 72.0054 107.913 71.8539 108.67 71.8774Z",
    fill: "#F34F42"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9143 79.1484C95.216 79.4587 95.4435 79.8332 95.5798 80.2439C95.7162 80.6546 95.7578 81.0908 95.7015 81.5199C95.7015 81.5199 91.9196 82.212 91.8737 82.212C91.9051 81.767 91.7973 81.3233 91.5651 80.9425C91.3329 80.5616 90.988 80.2625 90.5781 80.0865L94.9143 79.1484Z",
    fill: "#DBDBDB"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M108.728 81.2689C110.102 81.2689 111.215 79.166 111.215 76.572C111.215 73.9779 110.102 71.875 108.728 71.875C107.355 71.875 106.242 73.9779 106.242 76.572C106.242 79.166 107.355 81.2689 108.728 81.2689Z",
    fill: "#DBDBDB"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M108.879 80.7743C110.054 80.7743 111.007 78.8976 111.007 76.5825C111.007 74.2674 110.054 72.3906 108.879 72.3906C107.703 72.3906 106.75 74.2674 106.75 76.5825C106.75 78.8976 107.703 80.7743 108.879 80.7743Z",
    fill: "white"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M109.52 84.2969C110.346 85.5072 113.656 101.966 114.305 102.793C114.955 103.619 116.198 103.678 116.198 103.678L118.386 109.117C118.386 109.117 112.951 110.832 109.933 113.312C106.033 116.516 102.429 127.14 102.429 127.14C101.838 127.554 94.5106 130.568 92.5 130.686C92.5 130.686 101.845 120.426 102.606 106.227C102.901 100.726 99.5159 92.979 99.2962 89.1414C99.0534 85.0218 100.3 84.2969 102.488 84.2969H109.52Z",
    fill: "#F34F42"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0488 131.864L90.5859 130.48C98.7859 121.801 101.81 108.126 101.571 104.394C101.446 102.481 100.833 100.343 100.18 98.0764C99.4846 95.6591 98.6974 92.9203 98.3628 89.9453C98.0512 87.1836 98.3628 85.3992 99.3042 84.3332C100.246 83.2672 101.538 83.2705 102.397 83.2738H110.204V85.2877H102.394C101.643 85.2877 101.131 85.314 100.806 85.678C100.482 86.0421 100.059 86.99 100.367 89.7223C100.695 92.5267 101.413 95.0654 102.118 97.5188C102.801 99.8936 103.43 102.134 103.581 104.263C103.837 108.248 100.692 122.755 92.0488 131.864Z",
    fill: "#DBDBDB"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M114.345 107.293C114.805 108.986 116.251 110.062 117.576 109.701C118.901 109.34 119.607 107.677 119.144 105.988C118.682 104.299 117.235 103.216 115.91 103.577C114.585 103.938 113.883 105.604 114.345 107.293Z",
    fill: "#DBDBDB"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M114.841 107.157C115.251 108.666 116.504 109.637 117.639 109.328C118.774 109.02 119.357 107.547 118.951 106.048C118.544 104.549 117.288 103.569 116.156 103.877C115.025 104.185 114.431 105.648 114.841 107.157Z",
    fill: "white"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M108.543 107.014C108.179 105.311 107.785 103.615 107.444 101.91C107.103 100.204 106.788 98.4953 106.522 96.7799C106.263 95.1825 105.984 93.5688 105.883 91.9517C105.781 90.2625 105.883 88.5569 106.703 87.0317C106.704 87.0287 106.705 87.0254 106.706 87.022C106.706 87.0185 106.706 87.015 106.705 87.0117C106.704 87.0083 106.703 87.0052 106.7 87.0024C106.698 86.9997 106.696 86.9974 106.693 86.9957C106.69 86.9939 106.686 86.9928 106.683 86.9924C106.679 86.992 106.676 86.9922 106.673 86.9931C106.669 86.994 106.666 86.9956 106.663 86.9977C106.661 86.9999 106.658 87.0025 106.657 87.0055C105.814 88.2355 105.538 89.7148 105.492 91.181C105.497 92.7974 105.639 94.4105 105.919 96.0025C106.397 99.4986 107.054 102.968 107.887 106.397C108.362 108.335 108.976 110.241 109.632 112.124C109.632 112.13 109.634 112.136 109.638 112.14C109.643 112.144 109.648 112.147 109.655 112.147C109.661 112.147 109.666 112.144 109.671 112.14C109.675 112.136 109.677 112.13 109.677 112.124C109.286 110.412 108.908 108.708 108.543 107.014Z",
    fill: "black"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M78.1811 119.398V126.286H72.3033V121.071C72.3033 121.071 69.0233 119.414 68.3673 113.389C67.7769 107.931 72.1328 100.646 72.9593 99.3245L76.7018 99.2031V100.545C76.7018 100.545 74.2385 105.484 73.94 108.02C73.0511 115.659 78.1811 119.398 78.1811 119.398Z",
    fill: "black"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24145_355109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0546 113.703C47.0101 113.703 46.9657 113.706 46.9219 113.714L47.0883 113.703H47.0546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4267 114.93C54.3142 114.986 54.1559 115.072 53.946 115.202C53.7987 115.293 53.6749 115.38 53.5824 115.448C53.6458 115.815 53.6764 116.229 53.6763 116.681C53.6756 118.593 53.137 119.803 52.0102 119.803C51.0085 119.803 50.3579 118.697 50.3585 116.75C50.3591 114.71 51.0606 113.627 52.0247 113.627C52.5253 113.627 52.905 113.861 53.1732 114.279C53.2847 114.197 53.4479 114.072 53.6022 113.934C53.6926 113.855 53.7729 113.766 53.8411 113.668C53.4251 113.136 52.8425 112.844 52.0875 112.844C50.4349 112.844 49.4683 114.263 49.4675 116.775C49.4917 119.252 50.3572 120.587 51.9474 120.587C53.7501 120.587 54.6278 119.286 54.6286 116.74C54.6288 116.061 54.5621 115.453 54.4267 114.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1325 113.799C55.1148 113.891 54.9882 114.077 54.8382 114.215C54.7041 114.337 54.4065 114.448 53.9973 114.62C53.8025 114.702 53.5995 114.793 53.4105 114.895C53.3426 114.932 53.2765 114.97 53.2132 115.009C53.211 115.011 53.2086 115.012 53.2061 115.014C53.194 115.021 53.1816 115.029 53.1697 115.037C53.1486 115.05 53.1279 115.064 53.108 115.078C52.9883 115.161 52.8764 115.253 52.7735 115.356C52.872 115.211 53.0201 115.041 53.1828 114.869C53.1951 114.856 53.208 114.842 53.2204 114.829C53.2231 114.827 53.2255 114.825 53.2278 114.822C53.2702 114.778 53.3132 114.733 53.3562 114.689C53.534 114.508 53.7128 114.333 53.8482 114.194C53.9198 114.123 53.9873 114.049 54.0502 113.971C54.1797 113.798 54.1612 113.586 54.1407 113.481C54.1407 113.48 54.1405 113.479 54.1402 113.479C54.14 113.478 54.1396 113.478 54.1391 113.478C54.1387 113.477 54.1382 113.477 54.1376 113.477C54.137 113.477 54.1364 113.477 54.1358 113.477C54.1353 113.477 54.1347 113.477 54.1342 113.477C54.1337 113.477 54.1332 113.478 54.1329 113.478C54.1325 113.479 54.1323 113.479 54.1321 113.48C54.132 113.48 54.132 113.481 54.132 113.482C54.1375 113.622 54.0987 113.761 54.021 113.879C53.9809 113.939 53.9018 114.014 53.7991 114.1C53.6578 114.219 53.4717 114.359 53.2793 114.513C53.2696 114.521 53.2598 114.529 53.25 114.537C53.2477 114.539 53.2453 114.541 53.2428 114.543C53.2308 114.553 53.2186 114.563 53.2059 114.573C53.1999 114.578 53.1947 114.583 53.1887 114.587C53.1828 114.592 53.1768 114.597 53.1706 114.603C53.1647 114.607 53.1581 114.613 53.1521 114.618C53.0836 114.674 53.0154 114.732 52.9493 114.792C52.949 114.792 52.9487 114.792 52.9484 114.792C52.9482 114.792 52.9481 114.793 52.948 114.793C52.9355 114.804 52.9229 114.815 52.9102 114.827C52.9066 114.83 52.9029 114.833 52.8998 114.837C52.8105 114.918 52.7256 115.003 52.6456 115.093C52.5457 115.207 52.4576 115.331 52.3828 115.462C52.3824 115.462 52.3821 115.463 52.3819 115.463C52.3816 115.463 52.3815 115.464 52.3814 115.464C52.3788 115.468 52.3763 115.474 52.3739 115.478C52.3536 115.513 52.3352 115.548 52.3175 115.583C52.2498 115.718 52.1937 115.858 52.1501 116.001C52.1067 116.012 52.0648 116.028 52.0256 116.05C51.8655 116.137 51.3607 116.544 51.1787 116.743C51.0647 116.868 50.8999 116.955 50.7927 117.003C50.7672 117.014 50.7451 117.023 50.7276 117.03C50.7221 117.032 50.7173 117.036 50.7132 117.04C50.7092 117.044 50.7061 117.05 50.7042 117.055C50.7023 117.061 50.7016 117.067 50.7021 117.072C50.7027 117.078 50.7044 117.084 50.7073 117.089C50.7315 117.134 50.7601 117.176 50.7926 117.215C50.8397 117.274 50.8989 117.321 50.9662 117.356C51.1537 117.446 51.4753 117.359 51.6878 117.331C51.9001 117.303 52.0311 117.343 52.089 117.434C52.2129 117.629 52.0075 118.137 51.6365 118.312C51.5287 118.363 51.1641 118.478 50.9272 118.564C50.8903 118.577 50.8204 118.602 50.7648 118.621C50.7903 118.723 50.8707 118.873 50.9286 118.964C51.1974 119.385 51.5478 119.626 52.0128 119.626C52.3648 119.626 52.6711 119.475 52.8897 119.247C53.0449 119.081 53.1553 118.879 53.2109 118.66C53.3198 118.241 53.2648 117.972 53.2283 117.78C53.1938 117.6 53.1401 117.423 53.0682 117.254C52.9437 116.943 52.8346 116.786 52.7085 116.572C52.6392 116.454 52.6093 116.418 52.6755 116.363C52.7036 116.34 52.7332 116.361 52.7649 116.366C52.8973 116.386 53.0339 116.394 53.1553 116.32C53.1922 116.296 53.2247 116.266 53.2513 116.231C53.2885 116.185 53.3205 116.134 53.3512 116.09C53.3711 116.062 53.371 116.038 53.3368 116.02C53.3105 116.007 53.2817 115.993 53.2514 115.981C53.1158 115.926 52.9472 115.893 52.8134 115.956C52.7389 115.991 52.6908 116.03 52.6425 116.061C52.6344 116.067 52.6262 116.071 52.618 116.076C52.7712 115.874 52.9381 115.683 53.1174 115.503C53.1227 115.497 53.1281 115.492 53.1348 115.486C53.1462 115.475 53.159 115.463 53.172 115.451C53.1746 115.449 53.177 115.447 53.1793 115.445C53.258 115.376 53.3403 115.311 53.4257 115.25C53.6067 115.12 53.8224 114.983 54.0345 114.853C54.4183 114.618 54.682 114.469 54.8148 114.361C54.9991 114.209 55.1389 113.916 55.1424 113.8C55.1426 113.799 55.1422 113.798 55.1414 113.797C55.1406 113.796 55.1394 113.795 55.1381 113.795C55.1375 113.795 55.1368 113.795 55.1362 113.795C55.1356 113.795 55.135 113.795 55.1344 113.796C55.1334 113.796 55.1327 113.798 55.1325 113.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2569 118.235C42.2567 118.64 42.054 118.843 41.6486 118.843H40.319L40.3192 118.238H41.3991C41.5471 118.238 41.6211 118.167 41.6211 118.027L41.6213 117.565H40.824C40.4893 117.565 40.322 117.415 40.3221 117.114L40.3224 116.203C40.3225 115.899 40.4899 115.747 40.8246 115.747H41.7531C42.0895 115.747 42.2576 115.899 42.2575 116.203L42.2569 118.235ZM41.6165 116.804L41.6166 116.498C41.6166 116.401 41.5611 116.352 41.4501 116.352H41.1247C41.012 116.352 40.9556 116.401 40.9556 116.498L40.9555 116.804C40.9554 116.906 41.0118 116.957 41.1245 116.957H41.4499C41.5609 116.957 41.6165 116.906 41.6165 116.804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0734 118.235C44.0733 118.417 44.0237 118.563 43.9244 118.672C43.8201 118.786 43.6762 118.843 43.4929 118.843H42.6099L42.6101 118.205L43.1576 118.203C43.2686 118.201 43.3451 118.172 43.3872 118.114C43.4208 118.066 43.4377 117.985 43.4377 117.87L43.4384 115.747H44.0742L44.0734 118.235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.432 116.35H46.7635C46.5784 116.35 46.4859 116.441 46.4858 116.622L46.4857 116.962H46.9701C47.1552 116.962 47.2476 117.071 47.2476 117.287L47.2475 117.565C47.2474 117.914 47.1085 118.216 46.8309 118.471C46.56 118.719 46.2454 118.843 45.8872 118.843C45.502 118.843 45.1901 118.734 44.9513 118.516C44.7075 118.292 44.5856 117.993 44.5857 117.617L44.5863 115.749H45.2196L45.219 117.6C45.2189 117.799 45.2828 117.952 45.4106 118.062C45.5334 118.164 45.6973 118.215 45.9025 118.215C46.1145 118.215 46.2928 118.16 46.4374 118.049C46.5973 117.928 46.6772 117.767 46.6773 117.565H46.3594C46.023 117.565 45.8549 117.413 45.8549 117.109L45.8552 116.203C45.8553 115.897 46.0236 115.744 46.36 115.744H47.4322L47.432 116.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8748 115.198C48.8748 115.283 48.8436 115.355 48.7814 115.417C48.7191 115.478 48.6451 115.508 48.5593 115.508C48.4719 115.508 48.397 115.478 48.3348 115.417C48.2726 115.355 48.2415 115.283 48.2416 115.198C48.2416 115.112 48.2727 115.039 48.335 114.98C48.3972 114.92 48.4721 114.891 48.5595 114.891C48.647 114.891 48.721 114.92 48.7815 114.98C48.8437 115.039 48.8748 115.112 48.8748 115.198ZM48.8764 118.235C48.8763 118.417 48.8266 118.563 48.7274 118.672C48.623 118.786 48.4792 118.843 48.2959 118.843H47.4129L47.4131 118.205L47.9605 118.203C48.0715 118.201 48.1481 118.172 48.1902 118.114C48.2238 118.066 48.2407 117.985 48.2407 117.87L48.2414 115.747H48.8772L48.8764 118.235Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24145_355109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.451,
    height: 7.74302,
    fill: "white",
    transform: "matrix(1 0 -0.000321484 1 39.6953 112.844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeeroVehicle);
export default __webpack_public_path__ + "static/media/zeeroVehicle.42e1ba5eeae7df6b9d9ace76d8cea3fe.svg";
export { ForwardRef as ReactComponent };